import type { FC, ReactNode } from 'react';
import { Bleed, Box, Heading, Hidden, Stack } from 'braid-design-system';

export const JobSectionLayout: FC<{
  heading: ReactNode;
  details: ReactNode;
  jobAction: {
    desktop: ReactNode;
    mobile: ReactNode;
  };
  alert: ReactNode;
  modals: ReactNode;
}> = ({ heading, details, jobAction, alert, modals }) => (
  <div data-testid="job-information" data-intercom-target="job-information">
    <Box data-testid="title">
      <Stack space="none">
        <Box paddingX={['xsmall', 'small']} background="surface">
          <Box
            paddingTop={['large', 'xlarge']}
            paddingBottom={['small', 'large', 'small']}
          >
            <Stack space="medium">
              <Heading level="2">{heading}</Heading>
              <Box
                display="flex"
                justifyContent="spaceBetween"
                alignItems="center"
                flexWrap="wrap"
              >
                <Box paddingBottom="small">{details}</Box>
                <Box>
                  <Hidden below="tablet">
                    <Bleed left="small" top="small">
                      {jobAction.desktop}
                    </Bleed>
                  </Hidden>
                </Box>
              </Box>
            </Stack>
          </Box>
        </Box>
        <Hidden above="mobile">
          <Box
            paddingBottom="large"
            paddingX={['xsmall', 'small']}
            textAlign="right"
          >
            {jobAction.mobile}
          </Box>
        </Hidden>
      </Stack>
      {alert}
      {modals}
    </Box>
  </div>
);
